
export const WALLET_SETTINGS_URL = '/wallet/page';              // 获取钱包配置(user, wallet, withdraw)
export const WALLET_RECORDS_URL = '/wallet/walletRecords';      // 钱包交易历史
export const INVITE_CODE_URL = '/task/inputRefCode';            // 输入邀请码
export const INVITE_LIST_URL = '/task/inviterList';             // 邀请历史
export const WITHDRAW_URL = '/wallet/withdraw';                 // 提现